// @flow

import * as React from 'react';
import { navigateTo } from 'gatsby-link';
import { I18nProvider, withI18n } from '@lingui/react';
import { Helmet } from 'react-helmet';

import { Title } from './Title';
import { catalogs, langFromPath, langPrefix, defaultLanguage, alternateLanguage } from '../i18n-config';

import '../assets/scss/page.scss';

import { Nav } from './Nav';
import { Footer } from './Footer';

type SiteProps = {
  ...$Exact<Props>,
  lang: string,
  data: { site: { siteMetadata: {
    name: string, siteUrl: string,
  } } },
  children: (Object) => React.Node,
  location: { pathname: string },
}

const TemplateWrapper = withI18n()((props: SiteProps) => {
  const { i18n } = props;
  const { siteUrl } = props.data.site.siteMetadata;
  const prefix = langPrefix(props.lang);
  const thumbnailUrl = `${siteUrl}/thumbnail.png`;
  const { pathname } = props.location;
  const defaultPathname = `${siteUrl}${prefix ? pathname.substr(3) : pathname}`;
  return (
    <div>
      <Title
        title={i18n.t`site_title`}
        description={i18n.t`site_description`}
        thumbnailUrl={thumbnailUrl}
        name={i18n.t`site_name`}
      />
      <Helmet>
        <html lang={props.lang} />
        <meta name="keywords" content={i18n.t`site_keywords`} />
        <meta name="author" content="ESUnity" />

        <link rel="alternate" href={defaultPathname} hrefLang="x-default" />
        <link rel="alternate" href={defaultPathname} hrefLang={`${defaultLanguage}`} />
        <link rel="alternate" href={`${siteUrl}${prefix ? '' : `/${alternateLanguage}`}${pathname}`} hrefLang={`${alternateLanguage}`} />

        {/* Disable AOS for Google */}
        <noscript>
          {`
            <style>
              [data-aos] {
                  opacity: 1 !important;
                  transform: translate(0) scale(1) !important;
              }
            </style>
          `}
        </noscript>
      </Helmet>
      <Nav {...props} prefix={prefix} siteName={i18n.t`site_name`} />
      {props.children({ ...props, prefix })}
      <Footer {...props} prefix={prefix} />
    </div>
  );
});


export default class extends React.Component<{ location: { pathname: string } }> {
  componentDidMount = () => {
    const { pathname } = this.props.location;

    const lang = langFromPath(this.props.location.pathname);

    const prefix = langPrefix(lang);

    if (prefix && !pathname.startsWith(prefix)) {
      navigateTo(`/${prefix}${this.props.location.pathname}`);
    }
  }
  render = () => {
    const lang = langFromPath(this.props.location.pathname);
    return (
      <I18nProvider language={lang} catalogs={catalogs}>
        <TemplateWrapper {...this.props} lang={lang} />
      </I18nProvider>
    );
  }
}

// eslint-disable-next-line no-undef
export const pageQuery = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx